import {get, isEqual, omit} from "lodash"
import {cycleFieldsFragment} from "@irati/insights/apollo/gql/fragments/schedule"
import {CLONE_PREFIX} from "@irati/insights/apollo/constants"

const cycleCloneHasChanges = (client, clone) => {
  const cycleId = get(clone, "id") || ""
  const id = `Schedule@${cycleId.replace(CLONE_PREFIX, "")}`
  const cycle = client.cache.readFragment({id, fragment: cycleFieldsFragment})
  return !isEqual(omit(cycle, "id"), omit(clone, "id"))
}

export default cycleCloneHasChanges
